module.exports = __webpack_public_path__ + "img/biaoqian_shengchanjiagongqiye.2e45df1a.png";